/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDto } from '../../models/file-dto';

export interface StorageControllerUploadFiles$Params {
  bucket: string;
      body: {
'files'?: Array<Blob>;
}
}

export function storageControllerUploadFiles(http: HttpClient, rootUrl: string, params: StorageControllerUploadFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileDto>>> {
  const rb = new RequestBuilder(rootUrl, storageControllerUploadFiles.PATH, 'post');
  if (params) {
    rb.query('bucket', params.bucket, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FileDto>>;
    })
  );
}

storageControllerUploadFiles.PATH = '/api/storage';
